<!-- eslint-disable no-irregular-whitespace -->
<template>
  <div class="panel-body">
    <div class="box-multi-channel-service">
      <div class="m-n text-center">マルチチャネルサービス設定　提出状況</div>
      <div :class="['box-status', multiChannelSenderItem.statusClass]">{{ multiChannelSenderItem.status }}</div>
      <div :class="[`status-description description-${multiChannelSenderItem.statusClass}`]">
        <template v-if="multiChannelSenderItem.key === 'not_submitted'">
          <div class="description-not-submitted">マルチチャネルサービス設定の証跡画像が未提出です。</div>
        </template>
        <template v-else-if="multiChannelSenderItem.key == 'reviewing'">
          <div>ご提出いただいたマルチチャネルサービス設定の証跡画像を審査中です。</div>
          <div>審査中でも<router-link :to="{name: 'ProductsNew', params: {tab: 'list'}}" class="text--underline">商品管理画面</router-link>より商品を出品していただくことが可能です。</div>
        </template>
        <template v-else-if="multiChannelSenderItem.key == 'reviewed_ok'">
          <div>ご提出いただいたマルチチャネルサービス設定の証跡をご確認しました。</div>
          <div><router-link :to="{name: 'ProductsNew', params: {tab: 'list'}}" class="text--underline">商品管理画面</router-link>より商品を出品していただくことが可能です。</div>
        </template>
        <template v-else-if="multiChannelSenderItem.key == 'reviewed_not_good'">
          <div>ご提出いただいたマルチチャネルサービス設定の証跡に不備があります。</div>
          <div>マニュアルをご確認のうえ、再提出してください。</div>
        </template>
      </div>
      <div v-if="multiChannelSenderItem.isUploaded" class="m-b-sm reupload-text">再提出をされる方向け</div>
      <div class="box-status-content">
        <div class="service-guide">
          マニュアルを参考にマルチチャネルサービスの設定をして頂き、画面のキャプチャ画像をご提出ください。 <br>
          <a :href="documentMultiChannelSettingUrl" target="_blank" class="url-setting-service-manual">マルチチャネルサービス設定マニュアル</a>
        </div>
        <div>以下のボタンを選択した後、表示される画面よりファイルをご提出ください</div>
        <button type="button" class="btn btn-primary btn-updload-evidence" @click.prevent="openUploaderModal()">ファイルを提出する</button>
      </div>
      <div v-if="multiChannelSenderItem.isUploaded && evidenceImage" class="box-uploaded-evidence-image">
        <span>提出済画像（クリックで拡大）</span>
        <div class="box-evidence-image m-t-sm pd-l-30">
          <img class="evidence-image img-responsive" :src="evidenceImage" @click.prevent="showZoomInModal()">
        </div>
      </div>
    </div>

    <upload-evidence-image-modal
      @close="closeUploaderModal"
      @handleSuccess="uploadedEvidenceImageSuccess"
    />
    <zoom-in-evidence-image-modal
      v-if="showZoomInEvidenceImageModal"
      :imagePath="evidenceImage"
      @close="closeZoomInModal"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import UploadEvidenceImageModal from './UploadEvidenceImageModal'
import ZoomInEvidenceImageModal from './ZoomInEvidenceImageModal'
import EvidenceImageService from '@/services/evidenceimageservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    UploadEvidenceImageModal,
    ZoomInEvidenceImageModal
  },
  data () {
    return {
      showZoomInEvidenceImageModal: false,
      evidenceImage: ''
    }
  },

  created () {
    this.getEvidenceImage()
  },

  computed: {
    ...mapGetters({
      userInfo: 'getUser'
    }),
    multiChannelSenderItem () {
      let item = {
        status: null,
        key: null,
        statusClass: null,
        description: null,
        isUploaded: true
      }
      switch (this.userInfo.multiChannelSenderFlg) {
        case '0':
          item.status = '未提出'
          item.key = 'not_submitted'
          item.statusClass = 'status-not-submitted'
          item.isUploaded = false
          break
        case '1':
          item.status = '提出済：審査中'
          item.key = 'reviewing'
          item.statusClass = 'status-reviewing'
          break
        case '2':
          item.status = '提出済：審査OK'
          item.key = 'reviewed_ok'
          item.statusClass = 'status-reviewed-ok'
          break
        case '9':
          item.status = '提出済：審査NG'
          item.key = 'reviewed_not_good'
          item.statusClass = 'status-reviewed-not-good'
          break
      }
      return item
    },
    documentMultiChannelSettingUrl () {
      return 'https://image-yoshino.sakura.ne.jp/monster/documents/MultiChannelSetting.pdf'
    }
  },

  methods: {
    openUploaderModal () {
      $('#upload-evidence-image-modal').modal('show')
    },
    closeUploaderModal () {
      $('#upload-evidence-image-modal').modal('hide')
    },
    showZoomInModal () {
      this.showZoomInEvidenceImageModal = true
    },
    closeZoomInModal () {
      $('#zoom-in-evidence-image-modal').modal('hide')
      this.showZoomInEvidenceImageModal = false
    },
    getEvidenceImage () {
      EvidenceImageService.getEvidenceImage()
        .then((response) => {
          this.evidenceImage = response.data
          this.$events.fire('done')
        })
        .catch((error) => {
          this.$events.fire('done')
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    uploadedEvidenceImageSuccess () {
      this.userInfo.multiChannelSenderFlg = '1'
      this.$store.commit('setUser', this.userInfo)
      this.getEvidenceImage()
    }
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'multi-channel-service') {
      let logParams = {
        name: eventCode.warehouse_amazon.multi_channel_service_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
.box-status {
  width: 250px;
  margin: 0 auto 10px;
  padding: 5px;
  font-weight: bold;
  text-align: center;
}
.status-not-submitted {
  border: 2px solid #f5c6cb;
  background-color: #f8d7da;
  color: #721c24;
}
.status-reviewing {
  border: 2px solid #ed7d31;
  background-color: #fee599;
  color: #ed7d31;
}
.status-reviewed-not-good {
  border: 2px solid #f5c6cb;
  background-color: #f8d7da;
  color: #721c24;
}
.status-reviewed-ok {
  border: 2px solid #70ad47;
  background-color: #d6e9c6;
  color: #70ad47;
}
.status-description {
  width: 60%;
  margin: 0 auto 30px;
  padding-left: 40px;
}
.description-status-not-submitted {
  padding-left: 0px;
}
.description-not-submitted {
  color: red;
  text-align: center;
}
.reupload-text {
  width: 80%;
  margin: auto;
}
.box-status-content {
  width: 80%;
  margin: 0 auto 20px;
  background-color: #f1f3f6;
  border: 1px dashed #ddd;
  padding: 8px 18px;
  text-align: left;
}
.box-status-content .service-guide {
  color: red;
  margin-bottom: 10px;
}
.box-status-content .url-setting-service-manual {
  text-decoration: underline;
  color: #337ab7;
}
.box-status-content .url-setting-service-manual:hover {
  color: #23527c;
  text-decoration: none;
}
.btn-updload-evidence {
  margin-top: 5px;
  margin-left: 15px;
  padding: 3px 35px;
}
.box-evidence-image .evidence-image {
  height: 100px;
  width: auto;
  overflow: hidden;
}
.box-evidence-image .evidence-image:hover {
  cursor: pointer;
  opacity: 0.8;
}
.box-uploaded-evidence-image {
  width: 80%;
  margin: auto;
}
@media (max-width: 1200px) {
  .status-description {
    width: 72%;
  }
  .reupload-text {
    width: 100%;
    margin: auto;
  }
  .box-status-content {
    width: 100%;
  }
  .box-uploaded-evidence-image {
    width: 100%;
    margin: auto;
  }
}
@media (max-width: 768px) {
  .status-description {
    width: 70%;
  }
  .reupload-text {
    width: 100%;
    margin: auto;
  }
  .box-status-content {
    width: 100%;
  }
  .box-uploaded-evidence-image {
    width: 100%;
    margin: auto;
  }
}
@media (max-width: 576px) {
  .status-description {
    width: 100%;
    padding-left: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAmazon/MultiChannelService.vue